import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.243 6.34a1.097 1.097 0 1 1 2.194 0 1.097 1.097 0 0 1-2.194 0m4.03-3.84c.582 0 1.138.231 1.55.643l6.034 6.033c.857.857.857 2.25 0 3.107l-4.574 4.574a2.2 2.2 0 0 1-3.107 0l-6.033-6.035a2.2 2.2 0 0 1-.643-1.55V4.146c0-.91.737-1.646 1.646-1.646zM4.306 9.66l6.035 6.035a.544.544 0 0 0 .775 0l4.578-4.578a.544.544 0 0 0 0-.775L9.66 4.307a.55.55 0 0 0-.388-.161H4.146v5.126a.55.55 0 0 0 .16.388"
    }, null, -1)
  ]))]))
}
export default { render: render }